// 基础模块上下文

import { createContext, useContext, ReactNode } from "react";
import { useBaseCacheStore } from "../stores";

// Context类型定义
interface BaseCacheContextType {
  // 缓存数据
  cache: ReturnType<typeof useBaseCacheStore>;
}

// 创建Context
const BaseCacheContext = createContext<BaseCacheContextType | null>(null);

// Provider Props
interface BaseCacheContextProviderProps {
  children: ReactNode;
}

// Provider组件
export function BaseCacheContextProvider({
  children,
}: BaseCacheContextProviderProps) {
  const cache = useBaseCacheStore();

  const value: BaseCacheContextType = {
    cache,
  };

  return (
    <BaseCacheContext.Provider value={value}>
      {children}
    </BaseCacheContext.Provider>
  );
}

// Hook
export function useBaseCacheContext(): BaseCacheContextType {
  const context = useContext(BaseCacheContext);
  if (!context) {
    throw new Error(
      "useBaseCacheContext must be used within BaseCacheContextProvider"
    );
  }
  return context;
}

// 便捷hooks
export function useBaseCache() {
  const { cache } = useBaseCacheContext();
  return cache;
}
